/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiSuccess } from '../../models/api-success';

export interface DeleteFboLocation$Params {

/**
 * The ID of the FBO location to delete.
 */
  id: number;
}

export function deleteFboLocation(http: HttpClient, rootUrl: string, params: DeleteFboLocation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiSuccess>> {
  const rb = new RequestBuilder(rootUrl, deleteFboLocation.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiSuccess>;
    })
  );
}

deleteFboLocation.PATH = '/api/administration/fbo-locations/{id}';
